/**
 * Created by rathompson on 5/10/22
 * File: Constants
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

export const DEVICE_STATUSES = Object.freeze({
  COMPLETED: 'completed',
  FAILED: 'failed',
  ASSOCIATING: 'associating',
  DISSOCIATING: 'dissociating'
})

export const DEVICE_STATUS_BLACKLIST = [DEVICE_STATUSES.ASSOCIATING, DEVICE_STATUSES.DISSOCIATING]
